'use strict';

angular.module('webAgro1App').factory('PessoasService', function($http, RestService) {
  return {
    list: function(filters) {
      filters = filters || {};
      filters.no_paginate = true;

      var url = SERVER + API_VERSION + 'pessoas';
      return $http.get(url, {params: filters});
    },

    listMaoDeObra: function() {
      var filter = {mao_de_obra: true};
      return this.list(filter);
    },

    listPaginated: function(filters) {
      var params = !filters ? {} : {
        page: filters.page || null
      };
      return RestService.getFromUrl(SERVER + API_VERSION + 'pessoas', params);
    }
  };
});
